import fillCrudMetadataGaps from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
import { partialMetadata } from '../hotelPostSearchRule';
const x = fillCrudMetadataGaps({
  ...partialMetadata,
  name: 'SuperHotelPostSearchRule',
  path: '/hotelPostSearchRules',
  authorization: authorization('superuser', 'superuser')
});
export default x;